import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_CONTENT_LIST: any = createRequestTypes('cms/FETCH_CONTENT_LIST');
export const FETCH_CONTENT_DETAILS: any = createRequestTypes('cms/FETCH_CONTENT_DETAILS');
export const SAVE_CONTENT_DETAILS: any = createRequestTypes('cms/SAVE_CONTENT_DETAILS');
export const PUBLISH_CONTENT_DETAILS: any = createRequestTypes('cms/PUBLISH_CONTENT_DETAILS');

export const fetchContentList = {
  request: (params: any) => createAction(FETCH_CONTENT_LIST[REQUEST], { params }),
  success: (response: any, params: any) => createAction(FETCH_CONTENT_LIST[SUCCESS], { response, params }),
  failure: (response: any) => createAction(FETCH_CONTENT_LIST[FAILURE], { response }),
};

export const fetchContentDetails = {
  request: (params: any) => createAction(FETCH_CONTENT_DETAILS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(FETCH_CONTENT_DETAILS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(FETCH_CONTENT_DETAILS[FAILURE], { response }),
};

export const saveContentDetails = {
  request: (params: any) => createAction(SAVE_CONTENT_DETAILS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(SAVE_CONTENT_DETAILS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(SAVE_CONTENT_DETAILS[FAILURE], { response }),
};

export const publishContentDetails = {
  request: (params: any) => createAction(PUBLISH_CONTENT_DETAILS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(PUBLISH_CONTENT_DETAILS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(PUBLISH_CONTENT_DETAILS[FAILURE], { response }),
};
